var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPerformanceBoard = function SvgPerformanceBoard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.16 7.84v24.5a.98.98 0 01-.98.98H3.92v2.94c0 .541.439.98.98.98h39.2a.98.98 0 00.98-.98V7.84h-3.92z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.98 5.88h47.04a.98.98 0 010 1.96h-.98v28.42a2.943 2.943 0 01-2.94 2.94H29.65l3.546 6.384a.98.98 0 01-1.713.952L27.408 39.2h-5.816l-4.075 7.336a.98.98 0 01-1.714-.952L19.35 39.2H4.9a2.943 2.943 0 01-2.94-2.94V7.84H.98a.98.98 0 110-1.96zM44.1 37.24a.98.98 0 00.98-.98V7.84H3.92v28.42c0 .541.439.98.98.98h39.2z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 30.38c.26 0 .51-.103.693-.287l9.107-9.107 7.147 7.147a.98.98 0 001.386 0l9.107-9.107v3.514a.98.98 0 001.96 0v-5.88a.98.98 0 00-.98-.98h-5.88a.98.98 0 100 1.96h3.514l-8.414 8.414-7.147-7.147a.98.98 0 00-1.386 0l-9.8 9.8A.98.98 0 009.8 30.38z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPerformanceBoard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/performance-board.8a606833c7c4a66cfa5e09fc0c94b62f.svg";